import(/* webpackMode: "eager" */ "/Users/jerrod.a/Documents/Haulbase.ai/src/app/legal/error.tsx");
